import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@smpu-web/globalmodules/header"
import Footer from "@smpu-web/globalmodules/footer"
import Landing from "./landing"
import Block from "@bappweb/block"
import { useGetConfigListMutation } from "../api/services"
import { setSessionData } from "../state/sessionData"
import { useAppDispatch } from "../config/hook"
import { getCidParameter } from "@smpu-web/utils/utils"

const Main = () => {
  const routes = React.useMemo(
    () => ({
      Landing,
      Details: () => <Loadable loader={() => import("./details")} />,
      Result: () => <Loadable loader={() => import("./result")} />,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  const dispatch = useAppDispatch()
  const [getConfigList] = useGetConfigListMutation()

  React.useEffect(() => {
    let cidParameter = getCidParameter();

    getConfigList({
      functionCode: "MERC003",
      cid: cidParameter ?? "",
      TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
      NextTransactionUrl: "Facebook/SMPUConfig/GetConfigListWithFunctionCode1"
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          dispatch(
            setSessionData({
              configList: payload.configList
            })
          )
        }
      })
  }, [])

  return (
    <>
      <Block type="main" className="bapp-main">
        <Header />
        <Switch>
          <Route exact path="/" component={routes.Landing} />
          <Route path="/details/*" component={routes.Details} />
          <Route path="/result/*" component={routes.Result} />
          <Route component={routes.NotFound} />
        </Switch>
        <Footer />
      </Block>

    </>
  )
}

export default Main
